
export class PlanNumRecModel {
  public coopCode: string = <string>'';
  public coopName: string = <string>'';
  public planNum: string = <string>'';
  public limitNumTotal: string = <string>'';
  public limitNumPerson: string = <string>'';
  public deliveryLeadTimeType: string = <string>'';
  public delivCatalogID: string = <string>'';
  public enabled: string = <string>'';

  /**
   * コンストラクタ
   *
   * @param {Object} [obj=null]
   * @memberof PlanNumRecVO
   */
  public PlanNumRecVO(obj: any = null): void {

    if (obj != null) {
      this.coopCode = obj.CoopCode;
      this.coopName = obj.CoopName;
      this.planNum = obj.Plannum;
      this.limitNumTotal = obj.LimitnumTotal;
      this.limitNumPerson = obj.LimitnumPerson;
      this.deliveryLeadTimeType = obj.DeliveryLeadTimeType;
      this.delivCatalogID = obj.DelivCatalogID;
      this.enabled = obj.Enabled;
    }
  }

  public setXmlData(obj: any): void {
    if (obj != null) {
      this.coopCode = obj.CoopCode;
      this.coopName = obj.CoopName;
      this.planNum = obj.Plannum;
      this.limitNumTotal = obj.LimitnumTotal;
      this.limitNumPerson = obj.LimitnumPerson;
      this.deliveryLeadTimeType = obj.DeliveryLeadTimeType;
      this.delivCatalogID = obj.DelivCatalogID;
      this.enabled = obj.Enabled;
    }
  }

  public getXmlData(): any {

    const coopXML = {
      CoopCode: this.coopCode,
      CoopName: this.coopName,
      Plannum: this.planNum,
      LimitnumTotal: this.limitNumTotal,
      LimitnumPerson: this.limitNumPerson,
      DeliveryLeadTimeType: this.deliveryLeadTimeType,
      DelivCatalogID: this.delivCatalogID,
      Enabled: this.enabled,
    };
    return coopXML;
  }
}
